import Navbar from "../../shared/Navbar"

function ChurchInsuranceHeader() {
    return (
        <div id="wrapper" className='about-header-bg h-max pb-32'>
            <div className="relative grid md:grid-cols-6 md:gap-4 place-content-center z-10">
                <Navbar />
                <div className='col-start-2 col-span-4 text-center mt-48'>
                    <h1 className='mt-28 md:mt-0 text-7xl md:text-8xl text-white'>Church Insurance</h1>
                </div>
            </div>
        </div>
    )
}

export default ChurchInsuranceHeader